import SideMenu from '@/containers/side-menu/SideMenu.vue';
const AssignUserClient = () => import('@/pages/assign-user-client/AssignUserClient.vue');

export default {
  path: '/assign-user-client',
  name: 'AssignUserClient',
  components: {
    mainContent: AssignUserClient,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'assign-client-to-user',
    },
    breadcrumb: {
      title: 'Configurações',
      paths: [{ title: 'Sistema' }],
    },
  },
};
